<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="120px" v-loading="loading">
        <el-row :span="24">

          <el-col :span="24">
            <el-form-item prop="title" label="标题">
              {{ formData.title || '--' }}
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="content" label="记录内容">
              {{ formData.content || '--' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload view-type="img" v-model="formData.fileList" disabled readonly></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="事件记录">
              <el-table size="mini" stripe border style="margin-top:14px;" :data="formData.recordList">
                <el-table-column min-width="120" label="记录人" prop="createUserName"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" label="记录内容" prop="content"></el-table-column>
                <el-table-column min-width="120" label="记录时间" prop="ctime"></el-table-column>
                <el-table-column fixed="right" label="操作" width="90">
                  <template v-slot="{ row }">
                    <el-button type="text" @click="onDetail(row)">详情</el-button>

                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

    <el-dialog title="事件记录详情" class="global-dialog" v-if="showDetailDlg" :visible.sync="showDetailDlg" width="600px"
      :before-close="beforeClose">

      <div class="dlg-content">
        <el-form class="global-form " style="padding-top:20px" :model="currentRow" ref="form2" label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="记录人">
                {{ currentRow.createUserName || "--" }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="记录内容">
                {{ currentRow.content || "--" }}

              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="记录时间">
                {{ currentRow.ctime || "--" }}

              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="附件">
                <file-upload view-type="img" v-model="currentRow.fileList" disabled readonly></file-upload>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDetailDlg = false">取 消</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'eventRecordDetail',

  data () {
    return {
      formData: {

        title: '',
        content: '',
        fileList: [],
        recordList: []
      },

      loading: false,
      currentRow: {},
      showDetailDlg: false

    }
  },
  created () {
    if (this.eventId) {
      this.loadData()
    }
  },
  computed: {
    eventId () {
      return this.$route.query.eventId
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.eventRecord.selectYgnEventByEventId, {
          params: { eventId: this.eventId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          res.recordList = res.recordList ? res.recordList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    onDetail (row) {
      this.currentRow = row || {}
      this.showDetailDlg = true
    },
    beforeClose () {
      this.currentRow = {}
      this.showDetailDlg = false
    }

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
